<template>
  <div class="box flex">
    <div class="search-box">
      <a-input
        v-model:value="keyWord"
        placeholder="请输入"
        style="width: 400px"
        @change="keyWordSearch"
        @pressEnter="keyWordEnter(poisList)"
        allowClear
      />
      <!--搜索-->
      <div v-if="!showResult" class="search-result">
        <div class="flex" v-for="(item, index) in poisList" :key="index" @click="searchSelect(item)">
          <p>{{ item.name }}</p>
          <p class="address" :title="`${item.pname}${item.cityname}${item.adname}${item.address}`">
            {{ `${item.pname}${item.cityname}${item.adname}${item.address}` }}
          </p>
        </div>
      </div>
      <!--enter result-->
      <div v-else>
        <div class="select-result">
          <div v-show="upResult">
            <div
              v-for="(item, index) in selectList"
              :key="index"
              @click="keyWordSelect(item)"
              @mouseenter="listMouseoverOut(item, index, 'enter')"
              @mouseleave="listMouseoverOut(item, index, 'leave')"
              :class="{ 'select-result-active': listIndex === index }"
            >
              <span>{{ `${index + 1}.${item.name}` }}</span>
              <p class="address">{{ item.address }}</p>
            </div>
          </div>
          <!---收起搜索结果--->
          <div v-if="!upResult" @click="upResult = true" class="amap-search-panctrl">展开搜索结果</div>
        </div>
      </div>
    </div>
    <p style="margin-left: 10px">地址：{{ locationData.address || '--' }}</p>
  </div>
  <div id="container"></div>
</template>

<script setup lang="ts">
import AMapLoader from '@amap/amap-jsapi-loader'
import { reactive, ref, watch, PropType, onUnmounted, onMounted } from 'vue'
import type { SystemSetting } from '@/types/systemSetting'
import { cloneDeep } from 'lodash-es'
const img = require('@/assets/index/poi-marker-red.png')
const img2 = require('@/assets/index/poi-marker-default.png')
const emit = defineEmits(['mapData'])
const props = defineProps({
  editData: {
    type: Object as PropType<any>,
    default: () => {
      return {}
    }
  }
})
// 实例化点标记
const map = ref()
const AMapNew = ref()
const placeSearch = ref()
const infoWindow = ref()
const geocoder = ref()
const searchMarker = ref<any>([])
const marker = ref()
const locationData = reactive<any>({
  latAndLong: [],
  address: ''
})

const showResult = ref(false)
const upResult = ref(true)
const listIndex = ref(-1)

const keyWord = ref()
const poisList = ref([])
const selectList = ref<any[]>([])

watch(
  () => props.editData,
  (v) => {
    if (v.geoPoint) {
      const { longitude, latitude } = v.geoPoint
      if (longitude && longitude !== -9) {
        locationData.latAndLong = [longitude, latitude]
        locationData.address = v.address
      }
    }
  },
  { immediate: true }
)
// 添加点标记
const addMarker = (option: any, showInfo = true) => {
  marker.value = new AMapNew.value.Marker({
    icon: new AMapNew.value.Icon({
      image: img2,
      size: new AMapNew.value.Size(28, 35),
      imageSize: new AMapNew.value.Size(28, 35)
    }),
    position: [option.location.KL, option.location.kT],
    offset: new AMapNew.value.Pixel(-13, -30)
  })
  marker.value.setMap(map.value)
  if (showInfo) {
    marker.value.on('mouseover', () => {
      showInfoOver([option.location.KL, option.location.kT], option.name)
    })
  }
  // 是否需要居中放大显示
  map.value.setFitView()
}
// 确认选中
const setAddress = (option: any) => {
  locationData.address = `${option.pname}${option.cityname}${option.adname}${option.address}${option.name}`
  locationData.latAndLong = [option.location.KL, option.location.kT]
  emit('mapData', locationData)
}
// Map搜索地标详情
const getAddressByLat = (option: any) => {
  // 取详情
  geocoder.value.getAddress([option.location.KL, option.location.kT], function (status: string, result: any) {
    if (status === 'complete' && result.info === 'OK') {
      console.log(result)
      locationData.address = result.regeocode.formattedAddress
      locationData.latAndLong = [option.location.KL, option.location.kT]
      emit('mapData', locationData)
    }
  })
}
// 删除点标记
const clearMarker = () => {
  if (marker.value) {
    marker.value.setMap(null)
    marker.value = null
  }
}
// 进行地图初始化
function initMap() {
  AMapLoader.load({
    key: '7b8cdefc3a9ad93469dde19fe05c182a', // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '2.0'
  }).then((AMap) => {
    AMapNew.value = AMap
    const { latAndLong } = locationData
    map.value = new AMap.Map('container', {
      // 设置地图容器id
      viewMode: '3D', // 是否为3D地图模式
      zoom: 12, // 初始化地图级别
      animateEnable: false,
      center: latAndLong && latAndLong.length ? latAndLong : [114.05799949921004, 22.544114459133812]
    })
    // 添加插件
    AMap.plugin(['AMap.PlaceSearch', 'AMap.Geocoder'], function () {
      placeSearch.value = new AMap.PlaceSearch({
        city: '深圳',
        extensions: 'all'
      })
      geocoder.value = new AMap.Geocoder({})
      // 设置初始值locationData.latAndLong
      const { latAndLong } = locationData
      if (latAndLong?.length > 0) {
        const option = {
          location: {
            KL: latAndLong[0],
            kT: latAndLong[1]
          }
        }
        addMarker(option, false)
      }
    })
    // 单击
    map.value.on('click', (e: SystemSetting.MapLocation) => {
      clearMarker()
      const { KL, kT } = e.lnglat
      const option = {
        location: {
          KL,
          kT
        }
      }
      addMarker(option, false)
      getAddressByLat(option)
    })
    // dragend 拖拽隐藏搜索结果
    map.value.on('dragend', () => {
      upResult.value = false
    })
  })
}

// 显示信息窗体
const showInfoOver = (position: any, content: string) => {
  if (infoWindow.value) {
    infoWindow.value.setContent(content)
  } else {
    infoWindow.value = new AMapNew.value.InfoWindow({
      content,
      offset: new AMapNew.value.Pixel(-4, -30)
    })
  }
  infoWindow.value.open(map.value, position)
}
// 点标记和搜索结果鼠标移入事件

// 搜索点标签确定选中
const searchMarkerClick = (option: any) => {
  keyWordSelect(option)
}
const maskContent = (i: number, type: 'red' | 'default') => {
  const marker1 =
    '<div class="search-marker">' +
    '   <img src="' +
    img +
    '">' +
    '   <div class="search-marker-index">' +
    (i + 1) +
    '</div>' +
    '</div>'
  const marker2 =
    '<div class="search-marker">' +
    '   <img src="' +
    img2 +
    '">' +
    '   <div class="search-marker-index">' +
    (i + 1) +
    '</div>' +
    '</div>'
  return type === 'red' ? marker1 : marker2
}
// 批量添加点标记
const addMoreMarker = (markers: any) => {
  searchMarker.value = []
  markers.forEach((marker: any, i: number) => {
    const marker1 = maskContent(i, 'red')
    const marker2 = maskContent(i, 'default')
    const mark = new AMapNew.value.Marker({
      map: map.value,
      content: marker1,
      position: marker.position,
      offset: new AMapNew.value.Pixel(-12, -30)
    })
    mark.on('mouseover', () => {
      showInfoOver(marker.position, marker.name)
      mark.setContent(marker2)
      // 添加列表样式
    })
    mark.on('mouseout', () => {
      mark.setContent(marker1)
      listIndex.value = -1
    })
    mark.on('click', () => {
      searchMarkerClick(marker)
    })
    searchMarker.value.push(mark)
  })
  map.value.setFitView()
}
// 搜索
const keyWordSearch = () => {
  if (!keyWord.value) {
    poisList.value = []
    searchMarker.value && map.value.remove(searchMarker.value)
    infoWindow.value && infoWindow.value.close()
  }
  showResult.value = false
  placeSearch.value.search(keyWord.value, function (status: any, result: any) {
    if (result.poiList && result.poiList.pois) {
      // 过滤没有坐标的点
      poisList.value = result.poiList.pois.filter(
        (item: any) => item.location && item.location.lat && item.location.lng
      )
    }
  })
}
// 确认搜索结果选中
const keyWordSelect = (option: any) => {
  clearMarker()
  keyWord.value = option.name
  addMarker(option)
  setAddress(option)
}
// enter
const keyWordEnter = (arr: any) => {
  map.value.remove(searchMarker.value)
  setTimeout(() => {
    showResult.value = true
    upResult.value = true
    selectList.value = cloneDeep(arr)
    const list = arr.map((item: any) => {
      return {
        position: [item.location.KL, item.location.kT],
        ...item
      }
    })
    addMoreMarker(list)
  })
}
// 搜索直接选中
const searchSelect = (option: any) => {
  keyWordEnter([option])
  setTimeout(() => {
    keyWordSelect(option)
  })
}
// 列表mouseover
const listMouseoverOut = (option: any, listNum: number, type: 'enter' | 'leave') => {
  const { kT, KL } = option.location
  const index = searchMarker.value.findIndex((item: any) => item._position[0] === KL && item._position[1] === kT)
  if (index !== -1) {
    if (type === 'enter') {
      showInfoOver([KL, kT], option.name)
      const marker2 = maskContent(index, 'default')
      searchMarker.value[index].setContent(marker2)
      listIndex.value = listNum
    } else {
      const marker1 = maskContent(index, 'red')
      searchMarker.value[index].setContent(marker1)
      listIndex.value = -1
    }
  }
}
// 添加列表的选中样式
onMounted(() => {
  initMap()
})
onUnmounted(() => {
  map.value?.destroy()
})
</script>
<style lang="scss">
.search-marker {
  width: 25px;
  height: 35px;
  position: relative;
  img {
    width: 26px;
    height: 35px;
  }
  .search-marker-index {
    position: absolute;
    top: 5px;
    text-align: center;
    width: 100%;
    color: #fff;
    font-size: 12px;
  }
}
</style>
<style scoped lang="scss">
#container {
  padding: 0px;
  margin: 0px;
  width: 100%;
  min-height: 512px !important;
}
.box {
  padding: 20px 0;
  align-items: center;
}

.search-box {
  position: relative;
  width: 400px;
  .search-result,
  .select-result {
    width: 100%;
    position: absolute;
    top: 35px;
    z-index: 9999;
    background: #fff;
    max-height: 507px;
    overflow-y: auto;
    cursor: pointer;
    .flex {
      height: 32px;
      line-height: 32px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .address {
        color: #999;
        margin-left: 6px;
      }
    }
  }
  .select-result {
    div {
      border-top: 1px solid #eaeaea;
      padding: 4px 0;
      cursor: pointer;
      &:first-child {
        border: none;
      }
    }
    span {
      color: #333;
      line-height: 30px;
      font-weight: 500;
    }
    p {
      color: #999;
    }
    .amap-search-panctrl {
      background-color: #fff;
      padding: 12px 10px 5px;
      width: 100%;
      font-size: 14px;
      box-shadow: 1px 2px 1px rgb(0 0 0 / 10%);
      color: #0f89f5;
      text-align: center;
    }
    .select-result-active {
      background: #f3f9fe;
    }
  }
}
</style>
